import React, { useEffect, useState } from "react";
import * as _ from "lodash";
import {
  Table,
  Button,
  Form,
  Tabs,
  Tab,
  ButtonGroup,
  Row,
  Modal,
} from "react-bootstrap";
import AnimationLoading from "../../../components/AnimationLoading";
import { useLazyQuery, useMutation } from "@apollo/client";
import moment from "moment";
import Switch from "react-switch";
import { useToasts } from "react-toast-notifications";
import { GET_POST_STOCKS } from "../../../graphql/postStock/query";
import { imageRender } from "../../../helpers";
import { COLOR_APP } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faExclamationCircle,
  faPlus,
  faSave,
  faTimes,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import NumberFormat from "react-number-format";
import { GET_STOCKS } from "../../../graphql/stock/query";
import { UPDATE_STOCK } from "../../../graphql/stock/mutation";
import {
  CREATE_POST_STOCK,
  DELETE_POST_STOCK,
  UPDATE_POST_STOCK,
} from "../../../graphql/postStock/mutation";
import { CREATE_PRODUCT_AND_STOCKS } from "../../../graphql/product/mutation";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import ReactPaginate from "react-paginate";

function LiveDetailPostProduct({ liveData, postStocks, setPostStocks }) {
  const { height, width } = useWindowDimensions();
  const LIMIT_PAGE = 30;
  const { addToast } = useToasts()
  // const [postStocks, setPostStocks] = useState([]);
  const [displayPostStocks, setDisplayPostStocks] = useState([]);
  const [postStocksTotal, setPostStocksTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCountNumber, setPageCountNumber] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [editIndex, setEditIndex] = useState(null);

  const [amountAll, setAmountAll] = useState(null);

  const [showAddStock, setShowAddStock] = useState(false);
  const [isAlreadyExist, setIsAlreadyExist] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState({});

  const [currency, setCurrency] = useState("ກີບ");
  const [cfMessage, setCfMessage] = useState("");
  const [productTital, setProductTital] = useState("");
  const [stockPriceLak, setStockPriceLak] = useState(null);
  const [stockAmount, setStockAmount] = useState(null);

  const [selectedAddOption, setSeletedAddOption] = useState("");
  const [selectedStock, setSeletedStock] = useState({});
  const [searchKeyWord, setSearchKeyWord] = useState('');
  const [stocksData, setStocksData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Current page in the pagination
  const [stocksPerPage] = useState(50); // Number of stocks per page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages

  // const [getPostStocks, { data: postStockData }] = useLazyQuery(GET_POST_STOCKS, { fetchPolicy: "cache-and-network" });
  const [getStocks, { data: stockData, loading: stockLoading }] = useLazyQuery(GET_STOCKS, { fetchPolicy: "cache-and-network" });
  const [updateStock] = useMutation(UPDATE_STOCK)
  const [createPostStock] = useMutation(CREATE_POST_STOCK)
  const [updatePostStock] = useMutation(UPDATE_POST_STOCK)
  const [deletePostStock] = useMutation(DELETE_POST_STOCK)
  const [createProductAndStocks] = useMutation(CREATE_PRODUCT_AND_STOCKS);

  useEffect(() => {
    if (liveData?.id) {
      fetch();
    }
  }, [liveData])

  useEffect(() => {
    if (postStocks?.length > 0) fetch();
  }, [searchKeyWord, pageNumber, JSON.stringify(postStocks)])

  useEffect(() => {
    // Fetch all live stock data
    const fetchData = async () => {
      // Replace this with your actual data fetching logic
      setTotalPages(Math.ceil(displayPostStocks.length / stocksPerPage));
    };

    if (displayPostStocks?.length > 0) fetchData();
  }, [displayPostStocks]);

  const fetch = async () => {
    try {
      // let _where = {
      //     post: liveData?.id,
      //     isDeleted: false
      // };

      // if (searchKeyWord != '') _where = { ..._where, 'stock.name': searchKeyWord, cfMessage: searchKeyWord }
      // console.log({ _where })
      const _newPostStocks = postStocks?.filter(({ cfMessage, stock }) => {
        return cfMessage?.toLowerCase().includes(searchKeyWord?.toLowerCase()) || stock?.name?.toLowerCase().includes(searchKeyWord?.toLowerCase())
      })
      setDisplayPostStocks(_newPostStocks)
    } catch (err) {
      console.log({ err })
    }
  }

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1); // Since `ReactPaginate` is zero-indexed
  };

  const onSelectStock = async (e) => {
    const checkStock = stocksData.filter(stock => e?.target?.value.trim().split("ລະຫັດ: ")[0] != "" ? stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[0] : stock.cfMessage == e?.target?.value.trim().split("ລະຫັດ: ")[1])
    if (checkStock.length > 0) {
      setSeletedStock(checkStock[0])
      const checkCfMessage = postStocks.filter(item => item.cfMessage == checkStock[0]?.cfMessage)
      if (checkCfMessage.length > 0) setIsAlreadyExist(true)
      else setIsAlreadyExist(false)
    } else {
      setSeletedStock(null)
    }
  }

  const onAddStock = async () => {
    try {
      if (selectedAddOption === "ON_STOCK" && !isAlreadyExist && selectedStock?.id) {
        setShowAddStock(false)
        setIsLoading(true)
        const SHOP_ID = await localStorage.getItem("SHOP");
        await createPostStock({
          variables: {
            data: {
              amount: selectedStock?.amount,
              amountAll: selectedStock?.amount,
              cfMessage: selectedStock?.cfMessage,
              stock: selectedStock?.id,
              post: liveData?.id,
              fbFeedId: liveData?.fbFeedId,
              isDeleted: false,
              shop: SHOP_ID
            }
          }
        })
        const _updateStock = await updateStock({
          variables: {
            where: {
              id: selectedStock?.id
            },
            data: {
              amount: 0
            }
          }
        })
        if (_updateStock?.data?.updateStock) {
          window.location.reload()
        }
        setIsLoading(false)
      }
      if (selectedAddOption === "NEW" && !isAlreadyExist) {
        setShowAddStock(false)
        setIsLoading(true)
        const SHOP_ID = await localStorage.getItem("SHOP");
        const _createProductAndStocks = await createProductAndStocks({
          variables: {
            data: {
              product: {
                price: parseFloat((stockPriceLak ?? 0).toString().replace(/,/g, '')),
                amount: parseInt((stockAmount ?? 0).toString().replace(/,/g, '')),
                title: productTital ?? "",
                currency: currency ?? "",
                discount: 0,
              },
              stocks: [{
                price: parseFloat((stockPriceLak ?? 0).toString().replace(/,/g, '')),
                amount: parseInt((stockAmount ?? 0).toString().replace(/,/g, '')),
                currency: currency ?? "",
                name: productTital ?? "",
                cfMessage: cfMessage ?? ""
              }]
            },
            where: {
              shop: SHOP_ID
            }
          }
        })
        const _searchStock = await getStocks({
          variables: {
            where: {
              cfMessage: cfMessage,
              shop: SHOP_ID,
              product: _createProductAndStocks?.data?.createProductAndStocks?.id
            }
          }
        })
        if (_searchStock?.data?.stocks?.data.length > 0) {
          await createPostStock({
            variables: {
              data: {
                amount: parseInt((stockAmount ?? 0).toString().replace(/,/g, '')),
                amountAll: parseInt((stockAmount ?? 0).toString().replace(/,/g, '')),
                cfMessage: cfMessage,
                stock: _searchStock?.data?.stocks?.data[0].id,
                post: liveData?.id,
                fbFeedId: liveData?.fbFeedId,
                isDeleted: false,
                shop: SHOP_ID
              }
            }
          })
        }
        window.location.reload()
        // getPostStocks({
        //     variables: {
        //         where: {
        //             fbFeedId: liveData?.fbFeedId
        //         },
        //         limit: LIMIT_PAGE,
        //         skip: LIMIT_PAGE * (pageNumber - 1),
        //         orderBy: "createdAt_DESC"
        //     }
        // })
        setIsLoading(false)
      }
    } catch (error) {
      setShowAddStock(false)
      console.log(error);
      setIsLoading(false)
    }
  }

  const onSwitchStatus = async (data, index) => {
    let _postStocks = [...postStocks]
    updatePostStock({
      variables: {
        where: {
          id: data.id
        },
        data: {
          isPublished: !data.isPublished
        }
      }
    })

    _postStocks[index].isPublished = !data.isPublished
    setPostStocks(_postStocks)
    if (!data.isPublished) {
      addToast("ລະຫັດ " + data?.cfMessage + " ຖືກປິດໃຊ້ງານແລ້ວ!", {
        appearance: 'error',
        autoDismiss: true,
      })
    } else {
      addToast("ລະຫັດ " + data?.cfMessage + " ຖືກເປີດໃຊ້ງານແລ້ວ!", {
        appearance: 'success',
        autoDismiss: true,
      })
    }
  }

  const onDelectPostStock = async () => {
    try {
      const _deletePostStock = await deletePostStock({
        variables: {
          where: {
            id: deleteData.id
          }
        }
      })
      if (_deletePostStock?.data?.deletePostStock) {
        updateStock({
          variables: {
            where: {
              id: deleteData?.stock?.id
            },
            data: {
              amount: (deleteData?.stock?.amount ?? 0) + (deleteData?.amount ?? 0),
              isUsing: false,
            }
          }
        })
      }
      let _postStocks = [...postStocks]
      _.remove(_postStocks, { id: deleteData?.id })
      setPostStocks(_postStocks)
      setShowDeleteModal(false)
    } catch (error) {
      console.log("error: ", error);
    }
  }

  const onChangeCfMesaage = (e) => {
    setCfMessage(e?.target?.value)
    const checkCfMessage = postStocks.filter(item => item.cfMessage == e?.target?.value)
    if (checkCfMessage.length > 0) setIsAlreadyExist(true)
    else setIsAlreadyExist(false)
  }

  const onEditAmount = async () => {
    try {
      setShowEdit(false);

      let _amount = parseFloat(amountAll.toString().replace(/,/g, '')) + editData?.amount
      // const _updatePostStock = await updatePostStock({
      //     variables: {
      //         where: { id: editData?.id },
      //         data: {
      //             amountAll: amountAll ? (parseFloat(amountAll.toString().replace(/,/g, '')) + oldAmountAll) : oldAmountAll,
      //             amount: _amount >= 0 ? _amount : 0
      //         }
      //     }
      // })

      setEditData(null);
    } catch (error) {
      console.log(error);
    }
  }

  const thousand = num => num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0";

  const indexOfLastStock = currentPage * stocksPerPage;
  const indexOfFirstStock = indexOfLastStock - stocksPerPage;
  const currentStocks = displayPostStocks.slice(indexOfFirstStock, indexOfLastStock);

  return (
    <div>
      {/* {isLoading ? <AnimationLoading /> : <div />} */}
      <div style={{ display: "flex", flexDirection: "column", margin: '8px 0px 8px 8px' }}>
        <p style={{ fontSize: 20, margin: 0 }}>ລາຍການສິນຄ້າທີ່ເພີ່ມເຂົ້າໃນໂພສ ({displayPostStocks?.length ?? 0})</p>
        <Form.Control
          // className="mb-2 mx-2"
          style={{ width: '95%' }}
          type="text"
          name="searchKeyWord"
          placeholder="ຄົ້ນຫາຕາມຊື່ສິນຄ້າ ຫລື ລະຫັດ CF..."
          value={searchKeyWord}
          onChange={(e) => setSearchKeyWord(e.target.value)}
        />
      </div>

      <div>
        <Table responsive className="staff-table-list borderless table-hover">
          <thead style={{ background: "#F1F1F1", whiteSpace: 'nowrap' }}>
            <tr>
              <th style={{ width: 35, borderBottom: "none" }}>ລຳດັບ</th>
              <th style={{ borderBottom: "none" }}>ຮູບ</th>
              <th style={{ width: 50, borderBottom: "none" }}>ສິນຄ້າ</th>
              <th style={{ borderBottom: "none" }}>ລະຫັດ CF</th>
              <th style={{ borderBottom: "none" }}>ລາຄາ</th>
              <th style={{ width: 180, borderBottom: "none" }}>ຈຳນວນ</th>
              <th style={{ width: 130, borderBottom: "none" }}>ສະຖານະ</th>
              <th style={{ width: 200, borderBottom: "none" }}>ເວລາ</th>
              <th style={{ width: 130, borderBottom: "none" }}>ຈັດການ</th>
            </tr>
          </thead>
          <tbody>
            {currentStocks?.length > 0 &&
              currentStocks?.map((data, index) => (
                <tr key={index} style={{ whiteSpace: 'nowrap' }}>
                  <td style={{ width: 35 }}>{(stocksPerPage * (currentPage - 1)) + index + 1}</td>
                  <td style={{ width: 50 }}><img src={imageRender(data?.stock?.image ?? "")} style={{ borderRadius: "10%", cursor: 'pointer', height: 40, width: 40 }} /></td>
                  <td>
                    <div>
                      {data?.stock?.name || "ຍັງບໍ່ກໍານົດ"}
                      {data?.stock?.optionValues.length > 0 &&
                        data?.stock?.optionValues?.map((optionvalue, optionvalueIndex) => (
                          <span key={optionvalueIndex}>{" \t "} {optionvalue?.value} {" "}</span>
                        ))}
                    </div>
                  </td>
                  <td>{data?.cfMessage ?? ""}</td>
                  <td>{data?.stock?.price ? new Intl.NumberFormat('en-US').format(data?.stock?.price ?? 0) : "-"} {data?.stock?.currency ?? ""}</td>
                  <td style={{ width: 180 }}>
                    {showEdit && editData?.id == data?.id ? <span style={{ marginTop: 5 }}>ເພີ່ມ:</span> : <span>ເຫຼືອ:</span>} {showEdit && editData?.id == data?.id ? <NumberFormat
                      name="amountAll"
                      className="form-control"
                      onChange={(e) => setAmountAll(e?.target?.value ?? "")}
                      value={amountAll ?? ""}
                      placeholder="0"
                      styles={{ width: 180 }}
                      thousandSeparator={true} prefix={''} />
                      :
                      (<span>{thousand(data?.amount > 0 ? data?.amount : 0)} {" / "} {thousand(data?.amountAll > 0 ? data?.amountAll : 0)}</span>)
                    }
                    {/* {data?.amount ? new Intl.NumberFormat('en-US').format(data?.amount ?? 0) : "0"} / {data?.amountAll ? new Intl.NumberFormat('en-US').format(data?.amountAll ?? 0) : "0"} */}
                  </td>
                  <td style={{ width: 130 }}>
                    <Switch
                      checked={data.isPublished ?? false}
                      onChange={() => onSwitchStatus(data, index)}
                      onColor="#bfbdc7"
                      onHandleColor="#422f90"
                      handleDiameter={30}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={48}
                      className="react-switch"
                      id="material-switch"
                    />
                  </td>
                  <td style={{ width: 200 }}>{moment(data?.createdAt).format('DD/MM/YYYY HH:mm A')}</td>
                  {editData?.id != data?.id && <td style={{ width: 130 }}>
                    <button className="btn hoverme" onClick={() => {
                      setEditData(data)
                      setEditIndex(index)
                      setShowEdit(true)
                    }}>
                      <FontAwesomeIcon icon={faEdit} style={{ color: COLOR_APP }} />
                    </button>
                    <button className="btn hoverme" onClick={() => {
                      setDeleteData(data)
                      setShowDeleteModal(true)
                    }}>
                      <FontAwesomeIcon icon={faTrashAlt} style={{ color: "red" }} />
                    </button>
                  </td>}
                  {showEdit && editData?.id == data?.id && <td style={{ width: 130 }}>
                    <button className="btn hoverme align-self-start"
                      onClick={() => onEditAmount()}
                      style={{
                        borderColor: COLOR_APP,
                        color: COLOR_APP,
                      }}
                    >
                      <FontAwesomeIcon icon={faSave} style={{ borderColor: COLOR_APP, color: COLOR_APP }} />  ບັນທຶກ
                    </button>
                  </td>}
                </tr>
              ))}
          </tbody>
        </Table>
        {(totalPages > 1 && currentStocks.length > 0) &&
          <ReactPaginate
            previousLabel="ກັບຄືນ"
            onPageChange={handlePageClick}
            breakLabel="..."
            pageRangeDisplayed={5}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            renderOnZeroPageCount={null}
            containerClassName={"pagination justify-content-center"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
            forcePage={pageNumber - 1}
            nextLabel="ຕໍ່ໄປ"
          />
        }
      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <div>ຢືນຢັນການລຶບ</div>
        </Modal.Header>
        <Modal.Body style={{ padding: 24, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: "100%" }}>
          <FontAwesomeIcon icon={faExclamationCircle} style={{ fontSize: 90, color: "orange" }} />
          <br />
          <h5>ທ່ານຕ້ອງການທີ່ຈະລຶບ ສິນຄ້າອອກຈາກ Post ນີ້ແທ້ບໍ່?</h5>
        </Modal.Body>
        <Modal.Footer style={{ display: "flex", flexDirection: width > 700 ? "row" : "column", justifyContent: 'center', alignItems: 'center' }}>
          <Button
            variant="outline-dark"
            className="btn btn-app hoverme"
            style={{ width: 150 }}
            onClick={() => setShowDeleteModal(false)}
          >
            ກັບຄືນ
          </Button>
          <div style={{ width: 24 }} />
          <button
            className="btn btn-app hoverme"
            style={{ float: "left", background: "red", color: "#fff", width: 150 }}
            onClick={() => onDelectPostStock()}
          >
            ລຶບ
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default LiveDetailPostProduct;
